import { escapeHtml } from '@maximizer/shared/util';
import { EmailContent } from '../models/prefill-email';

export function renderEmailHtml(content: EmailContent): string {
  const sectionLines = content.sections.flatMap((section) => [
    `<p><strong>${escapeHtml(section.heading)}:</strong></p>`,
    '<ul>',
    ...section.items.map(
      (item) =>
        `  <li><strong>${escapeHtml(item.label)}:</strong> ${escapeHtml(
          item.value,
        )}</li>`,
    ),
    '</ul>',
  ]);

  const lines: string[] = [
    '<div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.6;">',
    `<p>${escapeHtml(content.greeting)}</p>`,
    ...content.paragraphs.map((paragraph) => `<p>${escapeHtml(paragraph)}</p>`),
    ...sectionLines,
    '</div>',
  ];

  return lines.join('\n');
}

export function renderEmailPlainText(content: EmailContent): string {
  const blocks: string[] = [content.greeting, ...content.paragraphs];

  for (const section of content.sections) {
    const sectionLines = [`${section.heading}:`];
    for (const item of section.items) {
      sectionLines.push(`- ${item.label}: ${item.value}`);
    }
    blocks.push(sectionLines.join('\n'));
  }

  return blocks.join('\n\n');
}
